import type { WorldMeta } from "../registry";

export const meta: WorldMeta = {
  id: "FW-42",
  name: "B-Side Society",
  slug: "b-side-society",
  title: "B-Side Society — a Fable World: music club waitlist",
  description:
    "An original music-club waitlist designed by Fable: a CSS-3D listening room where every beat arrives through a die-cut mask."
};

export default meta;
